import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PdfViewerFullScreenComponent } from './pdf-viewer-full-screen.component';
import { PageTitle } from '@app/commons/utils/enums';
import { AuthGuard } from '@app/guards/auth.guard';

const routes: Routes = [
  {
    path: 'documents/:documentId/full-screen',
    component: PdfViewerFullScreenComponent,
    canActivate: [AuthGuard],
    title: PageTitle.Documents,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PdfViewerFullScreenRoutingModule { }
